// =============================================================================
// Security Routes  —  /security
// =============================================================================
// Route registration for the security settings page.
// AuthGuard redirects unauthenticated users to sign-in.
//
// Related files:
//   src/pages/security.tsx                     → page wrapper
//   src/sections/security/SecurityView.tsx     → all visual content
//   src/layouts/nav-config-account.tsx         → "Security" entry in account drawer
// =============================================================================

import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const SecurityPage = lazy(() => import('../../pages/security'));

// ----------------------------------------------------------------------

export const securityRoutes: RouteObject[] = [
  {
    path: 'security',
    element: CONFIG.auth.skip ? (
      <Suspense fallback={<LoadingScreen />}>
        <DashboardLayout>
          <SecurityPage />
        </DashboardLayout>
      </Suspense>
    ) : (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <DashboardLayout>
            <SecurityPage />
          </DashboardLayout>
        </Suspense>
      </AuthGuard>
    ),
  },
];
